import { SellAreaCodeComboBoxComponent } from './sell-area-code-combo-box.component';
import { PlessViewUtilsSub } from '../../../kymw00/pless-view-utils-sub.service';
import { SellArea } from './sell-area.model';

/**
 * 売り場コードコンボボックスモデル
 *
 * @export SellAreaCodeComboBoxModel
 * @class SellAreaCodeComboBoxModel
 */
export class SellAreaCodeComboBoxModel {

  // 売り場コードリスト
  public dataList: SellArea[];
  // 先頭空白表示
  public blank: boolean = <boolean>true;
  // コードリスト取得完了
  public completeUpdateFlg: boolean = <boolean>false;
  // 初期設定コード値
  public setSellAreaCode: string = <string>'';
  // 初期データ自動取得フラグ
  public initAutoLoad: boolean = <boolean>false;
  // 媒体区分
  public mediumType: string = <string>'';
  // コンボボックスインスタンス
  public component: SellAreaCodeComboBoxComponent;


  /**
   * 売り場コードリストを更新する
   *
   * @param {*} serverData 売り場コードリスト取得データ
   * @memberof SellAreaCodeComboBoxModel
   */
  public updateDataList(serverData: SellArea[]): void {
    let tempDataList: SellArea[] = [];

    if (serverData !== null) {
      tempDataList = serverData;

      if (PlessViewUtilsSub.isEmptyArray(tempDataList)) {
        tempDataList = [];
      }
    }

    let index: number = <number>0;

    // 先頭空白追加
    if (this.blank) {
      const ob = new SellArea();
      tempDataList.splice(index, 0, ob);
      index = <number>1;
    }

    // コード+：+名称追加
    for (; index < tempDataList.length; index++) {
      tempDataList[index].SellAreaCodeName = tempDataList[index].SellAreaCode + ':' + tempDataList[index].SellAreaName;
    }

    this.dataList = tempDataList;

    this.completeUpdateFlg = true;
    this.component.updateSelectedSellAreaCode();
  }

}
